import { render, staticRenderFns } from "./SnapsSidebar.vue?vue&type=template&id=010ef10c&scoped=true&"
import script from "./SnapsSidebar.vue?vue&type=script&lang=js&"
export * from "./SnapsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SnapsSidebar.vue?vue&type=style&index=0&id=010ef10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ef10c",
  null
  
)

export default component.exports